import { EntityField } from "@skinsoft/types";

export const offlineItemSortEntityFields: EntityField[] = [
    {
        "id": "_itemInventoryNumber", // based on 5c50161dca5d4700015b3c92
        "className": "org.skinsoft.backend.types.entityfield.EntityField",
        "entity": "physicalMuseumItem",
        "abstractEntity": "museumItem",
        "schema": "identificationItemSchema",
        "name": "identifier",
        "mandatorySystem": false,
        "type": {
            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
            "type": "String"
        },
        "entityFields": [],
        "isChildren": true,
        "isInList": true,
        "path": "identificationItemSchema.identifiers.0.identifier.valueToSort",
        "pathType": "java.lang.String",
        "isReadOnly": false,
        "isComputed": false,
        "weight": 1E+08,
        "needId": false,
        "usableForFacets": true,
        "isFieldConditionNumbering": false,
        "lastModificationTimestamp": "1722523144078",
        "backwardSearchEnable": false,
        "fieldExcludeCheckInstitution": false
    },
    {
        "id": "_itemTitle",// based on 611fbac1dbd31457d95d86ee
        "className": "org.skinsoft.backend.types.entityfield.EntityField",
        "entity": "museumWork",
        "abstractEntity": "work",
        "schema": "descriptionMuseumWorkSchema",
        "name": "title",
        "mandatorySystem": false,
        "type": {
            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
            "type": "TranslatedString"
        },
        "entityFields": [],
        "isChildren": true,
        "isInList": true,
        "path": "descriptionMuseumWorkSchema.workTitles.0.title",
        "pathType": "org.skinsoft.backend.schemas.work.museumWork.descriptionMuseumWork.DescriptionMuseumWorkSchema|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
        "isReadOnly": false,
        "isComputed": false,
        "weight": 1E+10,
        "needId": false,
        "usableForFacets": true,
        "isFieldConditionNumbering": false,
        "lastModificationTimestamp": "1722523158968",
        "backwardSearchEnable": false,
        "fieldExcludeCheckInstitution": false
    },
]

export const offlineConditionReportSortEntityFields: EntityField[] = [
    {
        id: "_conditionReportInventoryNumber",// based on 5a3925ec08813b0001387c63
        className: 'org.skinsoft.backend.types.entityfield.EntityField',
        entity: 'conditionReport',
        schema: 'conditionReportCS',
        name: 'referenceNumber',
        mandatorySystem: false,
        type: {
          className: 'org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType',
          type: 'String'
        },
        entityFields: [],
        isChildren: false,
        isInList: false,
        path: 'conditionReportCS.referenceNumber.valueToSort',
        pathType: 'org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.lang.String',
        isReadOnly: false,
        isComputed: false,
        weight: 1,
        needId: false,
        usableForFacets: true,
        isFieldConditionNumbering: false,
        lastModificationTimestamp: "1734541319892",
        backwardSearchEnable: false,
        fieldExcludeCheckInstitution: false
    },    
]

export const offlineAuditCampaignSortEntityFields: EntityField[] = [
    {
        id: "_auditCampaignInventoryNumber", // based on 5e2713835111f87e825edddc
        className: 'org.skinsoft.backend.types.entityfield.EntityField',
        entity: 'auditProject',
        abstractEntity: 'project',
        schema: 'projectSchema',
        name: 'identificationNumber',
        mandatorySystem: false,
        type: {
        className: 'org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType',
        type: 'String'
        },
        entityFields: [],
        isChildren: false,
        isInList: false,
        path: 'projectSchema.identificationNumber.valueToSort',
        pathType: 'org.skinsoft.backend.schemas.project.projectschema.ProjectSchema|java.lang.String',
        isReadOnly: false,
        isComputed: false,
        weight: 100000000,
        needId: false,
        usableForFacets: true,
        isFieldConditionNumbering: true,
        lastModificationTimestamp: "1734541319892",
        backwardSearchEnable: false,
        fieldExcludeCheckInstitution: false
    },
]

export const offlineEntityFieldsForESFields: EntityField[] = [
    {
        id: "_conditionReportCurrentState", // based on 5e7b836714256b1944f069fa
        className: 'org.skinsoft.backend.types.entityfield.EntityField',
        entity: 'conditionReport',
        schema: 'workflowSchema',
        name: 'currentState',
        mandatorySystem: false,
        type: {
            className: 'org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType',
            type: 'LifecycleState'
        },
        entityFields: [],
        isChildren: false,
        isInList: false,
        path: 'workflowSchema.currentState.value',
        pathType: 'org.skinsoft.backend.schemas.conditionreport.ConditionReportWorkflowSchema|java.lang.String',
        isReadOnly: false,
        isComputed: true,
        weight: 1,
        needId: false,
        usableForFacets: true,
        isFieldConditionNumbering: false,
        lastModificationTimestamp: "1734541319892",
        backwardSearchEnable: false,
        fieldExcludeCheckInstitution: false,
    },
    {
        id: "_auditProjectCurrentState",// based on 5e2713835111f87e825ede00,
        className: 'org.skinsoft.backend.types.entityfield.EntityField',
        entity: 'auditProject',
        abstractEntity: 'project',
        schema: 'workflowSchema',
        name: 'currentState',
        mandatorySystem: false,
        type: {
        className: 'org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType',
        type: 'LifecycleState'
        },
        entityFields: [],
        isChildren: false,
        isInList: false,
        path: 'workflowSchema.currentState.value',
        pathType: 'org.skinsoft.backend.schemas.workflow.projectworkflowschema.ProjectWorkflowSchema|java.lang.String',
        isReadOnly: false,
        isComputed: true,
        weight: 1,
        needId: false,
        usableForFacets: true,
        isFieldConditionNumbering: false,
        lastModificationTimestamp: "1734541319892",
        backwardSearchEnable: false,
        fieldExcludeCheckInstitution: false
    }
]

export const offlineEntityFieldsForAdvancedSearches: EntityField[] = [
    {
        id: "_thesaurusTermThesaurus", // based on 59cb956f326d470001a93b3c, used in ThesaurusTermDataStore.searchOnRoot
        className: 'org.skinsoft.backend.types.entityfield.EntityField',
        entity: 'thesaurusTerm',
        schema: 'thesaurusTermSkin',
        name: 'thesaurus',
        mandatorySystem: false,
        type: {
          className: 'org.skinsoft.backend.types.entityfield.fieldtypes.ReferenceEntityFieldType',
          type: 'Thesaurus',
          subTypes: [],
          trueType: 'Thesaurus',
          useTrueType: false
        },
        entityFields: [],
        isChildren: false,
        isInList: false,
        path: 'thesaurusTermSkin.thesaurus.ref',
        pathType: 'org.skinsoft.backend.schemas.thesaurusterm.thesaurustermskin.ThesaurusTermSkin|org.skinsoft.backend.types.thesaurus.Thesaurus',
        isReadOnly: false,
        isComputed: true,
        weight: 1,
        needId: false,
        usableForFacets: true,
        isFieldConditionNumbering: false,
        lastModificationTimestamp: "1734541319892",
        backwardSearchEnable: false,
        fieldExcludeCheckInstitution: false
      }
]